/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Observable, ReplaySubject } from 'rxjs';
import { GridViewport, GridViewportControl, GridViewportRange, GridViewportRowData } from './grid-viewport.interfaces';

export function createImmutableGridViewport(): ImmutableGridViewport<any> {
  return new ImmutableGridViewport();
}

export class ImmutableGridViewport<T> implements GridViewport<T> {
  private _range = new ReplaySubject<GridViewportRange>(1);
  private _currentRange: GridViewportRange;
  private control: GridViewportControl;

  get range(): Observable<GridViewportRange> {
    return this._range.asObservable();
  }

  get currentRange(): GridViewportRange {
    return this._currentRange;
  }

  connect(control: GridViewportControl): void {
    this.control = control;
  }

  disconnect(): void {
    // nothing to do
  }

  setVisibleRange(range: GridViewportRange): void {
    this._currentRange = range;
    this._range.next(range);
  }

  setRowData(rowData: GridViewportRowData<T>): void {
    this.setRowData(rowData);
  }

  setRowCount(count: number): void {
    this.control.setRowCount(count);
  }
}
